import { colors } from '../constants';

// checkbox, radio group, switch

const styleOverrides = {
  root: {
    alignItems: 'start'
  },
  label: {
    paddingTop: 11,
    color: colors.text.primary
  }
};
const defaultProps = {
  color: 'inputElements'
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiFormControlLabel.js.map